/**
 * Tagify (v 3.18.1)- tags input component
 * By Yair Even-Or
 * Don't sell this code. (c)
 * https://github.com/yairEO/tagify
 */
!function (e, t) {
  "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? module.exports = t() : e.React.tagify = t();
}(this, function () {
  "use strict";

  function u(e) {
    return (u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  Object.defineProperty(exports, "__esModule", {
    value: !0
  }), exports.default = void 0;

  var e,
      H = function (e) {
    if (e && e.__esModule) return e;
    if (null === e || "object" !== u(e) && "function" != typeof e) return {
      default: e
    };
    var t = a();
    if (t && t.has(e)) return t.get(e);
    var n = {},
        r = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var o in e) {
      if (Object.prototype.hasOwnProperty.call(e, o)) {
        var i = r ? Object.getOwnPropertyDescriptor(e, o) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, o, i) : n[o] = e[o];
      }
    }

    n.default = e, t && t.set(e, n);
    return n;
  }(require("react")),
      L = require("react-dom/server"),
      t = require("prop-types"),
      Q = (e = require("./tagify.min.js")) && e.__esModule ? e : {
    default: e
  };

  function a() {
    if ("function" != typeof WeakMap) return null;
    var e = new WeakMap();
    return a = function a() {
      return e;
    }, e;
  }

  function U(e) {
    return function (e) {
      if (Array.isArray(e)) {
        for (var t = 0, n = new Array(e.length); t < e.length; t++) {
          n[t] = e[t];
        }

        return n;
      }
    }(e) || function (e) {
      if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
    }(e) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    }();
  }

  function X(e) {
    return e;
  }

  function n(e) {
    function t(e) {
      K.current = e;
    }

    var n = e.name,
        r = e.value,
        o = void 0 === r ? "" : r,
        i = e.loading,
        u = void 0 !== i && i,
        a = e.onInput,
        c = void 0 === a ? X : a,
        f = e.onAdd,
        l = void 0 === f ? X : f,
        s = e.onRemove,
        d = void 0 === s ? X : s,
        p = e.onEdit,
        y = void 0 === p ? X : p,
        v = e.onInvalid,
        g = void 0 === v ? X : v,
        m = e.onClick,
        b = void 0 === m ? X : m,
        h = e.onKeydown,
        w = void 0 === h ? X : h,
        O = e.onFocus,
        j = void 0 === O ? X : O,
        E = e.onBlur,
        S = void 0 === E ? X : E,
        M = e.onChange,
        x = void 0 === M ? X : M,
        R = e.readOnly,
        T = e.readonly,
        k = e.children,
        A = e.settings,
        N = void 0 === A ? {} : A,
        P = e.InputMode,
        _ = void 0 === P ? "input" : P,
        C = e.autoFocus,
        F = e.className,
        I = e.whitelist,
        q = e.tagifyRef,
        D = e.placeholder,
        V = void 0 === D ? "" : D,
        W = e.defaultValue,
        B = e.showDropdown,
        J = (0, H.useRef)(),
        K = (0, H.useRef)(),
        z = (0, H.useRef)(),
        G = (0, H.useMemo)(function () {
      return {
        ref: t,
        name: n,
        value: k || ("string" == typeof o ? o : JSON.stringify(o)),
        className: F,
        readOnly: T || R,
        onChange: x,
        autoFocus: C,
        placeholder: V,
        defaultValue: W
      };
    }, [W, V, C, F, k, x, R, o, n]);

    return (0, H.useEffect)(function () {
      !function (e) {
        if (e) for (var n in e) {
          String(e[n]).includes(".createElement") && function () {
            var t = e[n];

            e[n] = function (e) {
              return (0, L.renderToStaticMarkup)(H.default.createElement(t, e));
            };
          }();
        }
      }(N.templates), "textarea" == _ && (N.mode = "mix");
      var e = new Q.default(K.current, N);
      return c && e.on("input", c), l && e.on("add", l), d && e.on("remove", d), y && e.on("edit", y), g && e.on("invalid", g), w && e.on("keydown", w), j && e.on("focus", j), S && e.on("blur", S), b && e.on("click", b), q && (q.current = e), z.current = e, function () {
        e.destroy();
      };
    }, []), (0, H.useEffect)(function () {
      J.current && z.current.loadOriginalValues(o);
    }, [o]), (0, H.useEffect)(function () {
      var e;
      J.current && (e = z.current.settings.whitelist).splice.apply(e, [0, z.current.settings.whitelist.length].concat(U(I || [])));
    }, [I]), (0, H.useEffect)(function () {
      J.current && z.current.loading(u);
    }, [u]), (0, H.useEffect)(function () {
      var e = z.current;
      J.current && (B ? (e.dropdown.show.call(e, B), e.toggleFocusClass(!0)) : e.dropdown.hide.call(e));
    }, [B]), (0, H.useEffect)(function () {
      J.current = !0;
    }, []), H.default.createElement("div", {
      className: "tags-input"
    }, H.default.createElement(_, G));
  }

  n.propTypes = {
    name: t.string,
    value: (0, t.oneOfType)([t.string, t.array]),
    loading: t.bool,
    children: t.element,
    onChange: t.func,
    readOnly: t.bool,
    settings: t.object,
    InputMode: t.string,
    autoFocus: t.bool,
    className: t.string,
    tagifyRef: t.object,
    whitelist: t.array,
    placeholder: t.string,
    defaultValue: (0, t.oneOfType)([t.string, t.array]),
    showDropdown: (0, t.oneOfType)([t.string, t.bool])
  };
  var r = H.default.memo(n);
  r.displayName = "Tags";
  var o = r;
  return exports.default = o, r;
});